import React from 'react';
import { Link } from 'react-router-dom';
import { PROVIDERS, PICKS, byKey } from '../../lib/providers';

const AFFILIATE_REL = 'noopener noreferrer sponsored';

export default function ProviderGuide() {
  return (
    <div>
      <div className="cv-picks">
        {PICKS.map((pick) => {
          const p = byKey[pick.key];
          return (
            <div className="cv-pick" key={pick.key}>
              <span className="cv-pick-label">{pick.label}</span>
              <h3>{p.name}</h3>
              <div className="cv-pick-price">from {p.price} · {p.priceNote}</div>
              <p>{pick.why}</p>
              <a className="cv-btn cv-btn--sm" href={p.url} target="_blank" rel={AFFILIATE_REL}>See {p.name} →</a>
            </div>
          );
        })}
      </div>

      <h3 className="cv-table-title">Every provider, side by side</h3>
      <p className="cv-muted">Editorial guide based on each provider's published coverage and pricing. Prices are list prices and change often — confirm before you buy.</p>
      <div className="cv-prov" role="table" aria-label="History report providers">
        <div className="cv-prov-head" role="row">
          <span>Provider</span><span>Best for</span><span>Data strengths</span><span>Price</span><span />
        </div>
        {PROVIDERS.map((p) => (
          <div className="cv-prov-row" role="row" key={p.key}>
            <div className="cv-prov-name">{p.name}</div>
            <div>
              <div className="cv-prov-best">{p.bestFor}</div>
              <div className="cv-prov-skip">{p.skipIf}</div>
            </div>
            <div className="cv-chips">{p.strengths.map((s) => <span className="cv-chip" key={s}>{s}</span>)}</div>
            <div className="cv-price">{p.price}<small>{p.priceNote}</small></div>
            <div>
              <a className={`cv-btn cv-btn--sm${p.free ? ' cv-btn--ghost' : ''}`} href={p.url} target="_blank" rel={p.free ? 'noopener noreferrer' : AFFILIATE_REL}>{p.free ? 'Open tool →' : 'View →'}</a>
            </div>
          </div>
        ))}
      </div>
      <p className="cv-fineprint">Some links are affiliate links: we may earn a commission if you buy, at no extra cost to you. It does not change what we recommend — see <Link to="/how-we-work">How we work</Link>.</p>
    </div>
  );
}
